import events from './events';
import rest from '@/api/rest';
import Diode from '@/models/diode';


async function load() {
  const diodes = Object.values(await rest.get('/admin/diodes'));
  await Promise.all(diodes.map(async (diode) => {
    diode.heartbeat = await heartbeat(diode);
  }));
  Diode.create({data: diodes});
}

async function heartbeat(diode) {
  if (!diode.user || !diode.user.id) return;
  return events.last(diode.user.id, diode.serial);
}

// { user, serial, name, location }
async function create(data) {
  const diode = await rest.post('/admin/diodes', data);
  Diode.insertOrUpdate({data: diode});
  return diode;
}

// { user, name, location }
async function update(serial, data) {
  const diode = await rest.put(`/admin/diodes/${serial}`, data);
  Diode.insertOrUpdate({data: diode});
  return diode;
}

async function remove(serial, complete) {
  if (complete) {
    await rest.delete(`/admin/diodes/${serial}?complete=true`);
  } else {
    await rest.delete(`/admin/diodes/${serial}`);
  }
  Diode.delete(serial);
}

async function assign(serial, user) {
  // currently the backen has unassign before reassigning, probably better to move that safety check client side someday
  let diode = await rest.put(`/admin/diodes/${serial}`, {user: null});
  Diode.insertOrUpdate({data: diode});
  if (user) {
    diode = await rest.put(`/admin/diodes/${serial}`, {user: user});
    Diode.insertOrUpdate({data: diode});
  }
}

export default {
  load,
  create,
  update,
  remove,
  assign
};
